import ApiService from '../api.service';

const accountsService = {
    getAccounts: async payload => {
        try {
            const response = await ApiService.post('debt/getAccountsDebt', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    createPreTrialNotice: async payload => {
        try {
            const response = await ApiService.post('debt/addAccountsPreTrialNotice', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNotices: async function(payload) {
        try {
            const response = await ApiService.post('docs/getAccountsPreTrialNotice', payload);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNoticePDF: async payload => {
        try {
            const response = await ApiService.post('docs/getAccountsPreTrialNoticePDF', { pretrial_notices: payload }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    sendPdfToEmail: async payload => {
        try {
            const response = await ApiService.post('docs/sendAccountPreTrialNoticePDFToMail', payload, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getPreTrialNoticeDetails: async payload => {
        try {
            const response = await ApiService.get('docs/getAccountsPreTrialNoticeDetail', { params: { i_accounts_operation_action: payload } });
            return response.data;
        } catch (err) {
            console.error(err);
        }
    },
    editPreTrialNoticeDetails: async payload => {
        try {
            const { receiver_name, id, doc_delivery_date, comment, e_mail, contacts_receiver } = payload;
            const payloadData = {
                account_operation_action_rid: id,
                doc_delivery_date,
                receiver_name,
                comment,
                contacts_receiver,
                e_mail
            };
            const response = await ApiService.post('docs/editAccountsPreTrialNotice', { nvcOperationActionData: payloadData }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getContractsPreTrialNoticeToSign: async payload => {
        try {
            const response = await ApiService.get('docs/getAccountsPreTrialNoticeToSign', { params: { pretrial_notice_rid: payload } }, { showLoader: true });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    deleteAccountPreTrialNotice: async payload => {
        try {
            const response = await ApiService.delete(`docs/delAccountPreTrialNotice?pretrial_notice_rid=${payload}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default accountsService;
